
import { Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { ShippingService } from '../services/shipping.service';
import { distinctUntilChanged, switchMap, map } from 'rxjs/operators'
import { Observable } from 'rxjs';
import { IShippingDtoModel } from '../models/shipping/dto/shipping.dto.model';
import { IShippingMethod } from '../models/shipping/shipping-method.model';

@Pipe({
    name: "toShippingMethodTitle",
    pure: false
})
export class ToShippingMethodTitle {
    private shippingMethodId: string = 'loading';
    private valueSubject = new Subject();
    
    private value$ = this.valueSubject.asObservable()
    .pipe(
        distinctUntilChanged(),
        switchMap(value => {
            return this.shippingService.getShippingMethodDetails(this.shippingMethodId)
        }),
        map((shippingMethodTitle) => shippingMethodTitle.title)
    );

    constructor(private shippingService: ShippingService) { }

    transform(value: string): Observable<string> {
        this.shippingMethodId = value;
        this.valueSubject.next(value);
        return this.value$;
    }
}